module.exports = __webpack_public_path__ + "img/swipe3.24eae445.png";